import { Link } from 'react-router-dom';

const ServiceGrid = () => {
  const services = [
    {
      icon: 'ri-car-fill',
      title: 'Collision Repair',
      description: 'Complete accident repair services including frame straightening, panel replacement, and structural repairs. Our certified technicians restore your vehicle to factory specifications.',
      features: ['Frame Straightening', 'Panel Replacement', 'Structural Repairs', 'Unibody Repair']
    },
    {
      icon: 'ri-paint-brush-fill',
      title: 'Auto Painting',
      description: 'Professional paint matching and application using state-of-the-art equipment and premium automotive paints for a flawless, long-lasting finish.',
      features: ['Color Matching', 'Full Body Paint', 'Spot Repairs', 'Clear Coat Application']
    },
    {
      icon: 'ri-hammer-fill',
      title: 'Dent Removal',
      description: 'Expert dent repair using both traditional and paintless dent removal techniques to restore your vehicle\'s appearance without compromising the original finish.',
      features: ['Paintless Dent Repair', 'Hail Damage Repair', 'Door Dings', 'Minor Collision Dents']
    },
    {
      icon: 'ri-tools-fill',
      title: 'Mechanical Services',
      description: 'Comprehensive mechanical repairs including engine diagnostics, brake service, suspension work, and electrical system repairs by ASE-certified mechanics.',
      features: ['Engine Diagnostics', 'Brake Repair', 'Suspension Work', 'Electrical Systems']
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Insurance Work',
      description: 'We work with all major insurance companies and handle the entire claims process. Direct billing available for your convenience and peace of mind.',
      features: ['All Insurance Accepted', 'Direct Billing', 'Claims Assistance', 'Warranty Work']
    },
    {
      icon: 'ri-truck-fill',
      title: '24/7 Towing Service',
      description: 'Emergency towing and roadside assistance available day and night throughout Brooklyn, Manhattan, Queens, and all NYC boroughs. Fast response times guaranteed.',
      features: ['24/7 Availability', 'Emergency Towing', 'Roadside Assistance', 'Accident Recovery']
    },
    {
      icon: 'ri-settings-3-fill',
      title: 'Maintenance & Inspection',
      description: 'Regular maintenance services and comprehensive vehicle inspections to keep your car running safely and efficiently. Preventive care saves money.',
      features: ['Oil Changes', 'Safety Inspections', 'Tune-Ups', 'Preventive Maintenance']
    },
    {
      icon: 'ri-car-washing-fill',
      title: 'Detailing Services',
      description: 'Professional interior and exterior detailing to restore your vehicle\'s showroom appearance. Complete cleaning and protection packages available.',
      features: ['Interior Detailing', 'Exterior Polish', 'Paint Protection', 'Upholstery Cleaning']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-['Playfair_Display']">
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Expert auto repair and maintenance services from experienced mechanics in Brooklyn
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-2xl mb-6">
                <i className={`${service.icon} text-3xl text-orange-600`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>

              <ul className="space-y-3 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-orange-600 text-lg mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-orange-600 font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap"
              >
                Request Quote
                <i className="ri-arrow-right-line"></i>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-orange-600 to-orange-700 rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4 font-['Playfair_Display']">
            Need Help Choosing a Service?
          </h3>
          <p className="text-lg text-white/95 mb-8 max-w-2xl mx-auto">
            Our experienced mechanics are here to help. Call us for a free consultation and estimate on any auto repair or maintenance service.
          </p>
          <a
            href="tel:+17185550100"
            className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call (718) 555-0100
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServiceGrid;
